import { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import { useBridgeState } from '@digitaz/bridge-sdk-client';
import { lightColors } from './light';
import { darkColors } from './dark';
import { ThemeType } from './constants';
import { getCurrentTheme } from './helpers/getCurrentTheme';

interface ThemeWrapperProps {
  children: ReactNode;
  initialThemeType: ThemeType;
}

export const ThemeWrapper = ({
  children,
  initialThemeType = ThemeType.light
}: ThemeWrapperProps) => {
  const { isWebView, insets } = useBridgeState();

  const colors =
    initialThemeType === ThemeType.light ? lightColors : darkColors;
  const theme = getCurrentTheme({ colors, isWebView, insets });
  return (
    <ThemeProvider theme={{ ...theme, mode: initialThemeType }}>
      {children}
    </ThemeProvider>
  );
};
